import { Field, useFormState } from "react-final-form";
import { useIntl } from "react-intl";
import dayjs from "dayjs";
import Section from "../../../common/section";
import { DatePicker, TextInput } from "../../../common/fields";
import * as Validations from "../../../common/form/validator";

const EnterpriseLicenseForm = ({ error, requesting, action }) => {
  const intl = useIntl();
  const formState = useFormState();

  const minEndate = formState.values?.license?.startDate
    ? dayjs(formState.values.license.startDate, "DD MMMM YYYY")
        .add(30, "day")
        .toDate()
    : new Date();

  let subDomainMeta = {
    error: formState?.errors?.subDomain,
    touched: formState?.touched?.subDomain,
  };
  if (
    error?.response === "SUBDOMAIN_ALREADY_IN_USE" &&
    action === "create" &&
    !requesting
  ) {
    subDomainMeta = {
      error: "subDomainExists",
      touched: true,
    };
  }

  return (
    <div className="grid gap-2">
      <Section title="license" className="col-12">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="subDomain"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "subDomain",
              })}
              placeholder={intl.formatMessage({
                id: "subDomain",
              })}
              meta={subDomainMeta}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="license.startDate"
              component={DatePicker}
              type="text"
              label={intl.formatMessage({
                id: "startDate",
              })}
              placeholder={intl.formatMessage({
                id: "startDate",
              })}
              minDate={new Date()}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="license.endDate"
              component={DatePicker}
              type="text"
              label={intl.formatMessage({
                id: "endDate",
              })}
              placeholder={intl.formatMessage({
                id: "endDate",
              })}
              minDate={minEndate}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </div>
      </Section>
      <Section title="entitlements" className="col-12">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="entitlements[0].value"
              component={TextInput}
              type="number"
              placeholder={intl.formatMessage({
                id: "no_of_users",
              })}
              label={intl.formatMessage({
                id: "no_of_users",
              })}
              maxLength={10}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="entitlements[1].value"
              component={TextInput}
              type="number"
              placeholder={intl.formatMessage({
                id: "storage",
              })}
              label={intl.formatMessage({
                id: "storage",
              })}
              maxLength={10}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </div>
      </Section>
      <Section title="super_admin_details" className="col-12">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="superAdmin.email"
              component={TextInput}
              type="email"
              icon="pi-envelope"
              placeholder={intl.formatMessage({
                id: "email",
              })}
              label={intl.formatMessage({
                id: "email",
              })}
              required
              validate={Validations.composeValidators(
                Validations.required,
                Validations.checkEmailFormat
              )}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="superAdmin.firstName"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "first_name",
              })}
              placeholder={intl.formatMessage({
                id: "first_name",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="superAdmin.lastName"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "last_name",
              })}
              placeholder={intl.formatMessage({
                id: "last_name",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default EnterpriseLicenseForm;
